import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Phone, Home } from 'lucide-react';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center pt-24">
      <SEO title="Page Not Found | Aero Time Critical" description="The page you are looking for could not be found." path="/404" />
      <div className="text-center px-4">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="text-8xl md:text-9xl font-bold text-[#0089D0]">404</div>
          <h1 className="text-3xl md:text-4xl font-bold text-[#003057] mt-4 mb-4">Page Not Found</h1>
          <p className="text-[#4A4A4A] text-lg mb-8 max-w-md mx-auto">
            The page you're looking for doesn't exist. Our team is available 24/7 for urgent freight.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/"><button className="btn-primary flex items-center gap-2"><Home size={18} /> Back to Home</button></Link>
            <a href="tel:+441753720055"><button className="btn-outline flex items-center gap-2"><Phone size={18} /> Call 24/7 Support</button></a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
